import { Injectable } from '@angular/core';
import { Response, RequestOptions, URLSearchParams } from '@angular/http';

import { AuthHttp } from 'app/infrastructure/common/index';
import { AppSettings } from 'app/infrastructure/settings/index';
import { AdvancedShippingNotice } from 'app/data/models/transaction/op/inbound/asn';

@Injectable()
export class OnlineShippingNoticeService {
    constructor(private http: AuthHttp) { }

    requestGetAsnTranscodes(): any {
        return this.http.get(AppSettings.apiEndpoint + 'OnlineAdvancedShippingNotice/GetAsnTranscodes')
            .map((response: Response) => response.json());
    }
    requestGetProductSuppliers(searchText:string): any {
        let params: URLSearchParams = new URLSearchParams();
        params.set("searchText", searchText);

        let options: RequestOptions = new RequestOptions({ search: params });
        return this.http.get(AppSettings.apiEndpoint + 'OnlineAdvancedShippingNotice/GetProductSuppliers', options)
            .map((response: Response) => response.json());
    }
    requestGetProducts(searchParams:any): any {
        let params: URLSearchParams = new URLSearchParams();
        params.set("OwnerCode", searchParams.OwnerCode);
        params.set("ProdCode", searchParams.ProdCode);
        params.set("Description", searchParams.Description);
        params.set("Page", searchParams.Page);
        params.set("PageSize", searchParams.PageSize);

        let options: RequestOptions = new RequestOptions({ search: params });
        return this.http.get(AppSettings.apiEndpoint + 'OnlineAdvancedShippingNotice/GetProducts', options)
            .map((response: Response) => response.json());
    }
    requestGetDocuments(ownerCode: string, onlineAsnNo: string) {
        let params: URLSearchParams = new URLSearchParams();
        params.set("ownerCode", ownerCode);
        params.set("onlineAsnNo", onlineAsnNo);

        let options: RequestOptions = new RequestOptions({ search: params });
        return this.http.get(AppSettings.apiEndpoint + 'OnlineAdvancedShippingNotice/GetDocuments', options)
            .map((response: Response) => response.json());
    }
    requestGetAsns(searchParams:any): any {
        let params: URLSearchParams = new URLSearchParams();
        params.set("DateFormat", searchParams.DateFormat);
        params.set("OwnerCode", searchParams.OwnerCode);
        params.set("AsnNo", searchParams.AsnNo);
        params.set("PoNo", searchParams.PoNo);
        params.set("Transcode", searchParams.Transcode);
        params.set("SupplierName", searchParams.SupplierName);
        params.set("StatusCode", searchParams.StatusCode);
        params.set("Page", searchParams.Page);
        params.set("PageSize", searchParams.PageSize);

        for (let key in searchParams) {
            let value = undefined;

            if (searchParams[key] && searchParams[key] instanceof Date) {
                value = searchParams[key].toUTCString();
            } else {
                value = searchParams[key];
            }

            params.set(key, value);
        }

        let options: RequestOptions = new RequestOptions({ search: params });
        return this.http.get(AppSettings.apiEndpoint + 'OnlineAdvancedShippingNotice/GetListOnlineShippingNotice', options)
            .map((response: Response) => response.json());
    }
    requestGetAsn(ownerCode:string,asnNo:string,dateFormat:string): any {
        let params: URLSearchParams = new URLSearchParams();
        params.set("OwnerCode", ownerCode);
        params.set("OopAsnNo", asnNo);
        params.set("DateFormat", dateFormat);

        let options: RequestOptions = new RequestOptions({ search: params });
        return this.http.get(AppSettings.apiEndpoint + 'OnlineAdvancedShippingNotice/GetOnlineShippingNotice', options)
            .map((response: Response) => response.json());
    }
    saveOnlineShippingNotice(asn: AdvancedShippingNotice) {
        return this.http.post(AppSettings.apiEndpoint + "OnlineAdvancedShippingNotice/SaveOnlineShippingNotice", asn)
            .map((response: Response) => response.json());
    }
    deleteShippingNotice(oopAsnId: string) {
        let params: URLSearchParams = new URLSearchParams();
        params.set('oopAsnId', oopAsnId);

        let options: RequestOptions = new RequestOptions({ search: params });
        return this.http.delete(AppSettings.apiEndpoint + "OnlineAdvancedShippingNotice/DeleteShippingNotice", options)
            .map((response: Response) => response.json());
    }
}


// WEBPACK FOOTER //
// ./src/app/infrastructure/services/transaction/op/inbound/asn/online-shipping-notice.service.ts